"use client"

import { usePathname } from "next/navigation"
import Link from "next/link"
import { ChevronRight, Home } from "lucide-react"

interface BreadcrumbItem {
  label: string
  href: string
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[]
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  const pathname = usePathname()

  // If custom items are provided, use them
  if (items) {
    return (
      <div className="flex items-center text-sm">
        <Link
          href="/"
          className="flex items-center text-light-text-secondary dark:text-dark-text-secondary hover:text-primary transition-colors"
        >
          <Home size={16} />
        </Link>
        {items.map((item, index) => (
          <div key={index} className="flex items-center">
            <ChevronRight size={14} className="mx-2 text-light-text-secondary dark:text-dark-text-secondary" />
            {index === items.length - 1 ? (
              <span className="text-primary font-medium italic">{item.label}</span>
            ) : (
              <Link
                href={item.href}
                className="text-light-text-secondary dark:text-dark-text-secondary hover:text-primary transition-colors"
              >
                {item.label}
              </Link>
            )}
          </div>
        ))}
      </div>
    )
  }

  // Default breadcrumb logic
  const segments = pathname.split("/").filter(Boolean)

  return (
    <div className="flex items-center text-sm">
      <Link
        href="/"
        className="flex items-center text-light-text-secondary dark:text-dark-text-secondary hover:text-primary transition-colors"
      >
        <Home size={16} />
      </Link>

      {segments.length > 0 && (
        <>
          <ChevronRight size={14} className="mx-2 text-light-text-secondary dark:text-dark-text-secondary" />
          <span className="text-light-text-primary dark:text-dark-text-primary font-medium">
            {segments.length === 0
              ? "Dashboard"
              : segments[segments.length - 1].charAt(0).toUpperCase() + segments[segments.length - 1].slice(1)}
          </span>
        </>
      )}

      {segments.length === 0 && (
        <>
          <ChevronRight size={14} className="mx-2 text-light-text-secondary dark:text-dark-text-secondary" />
          <span className="text-light-text-primary dark:text-dark-text-primary font-medium">Dashboard</span>
        </>
      )}
    </div>
  )
}
